import { render, staticRenderFns } from "./FasserramentiLogo.vue?vue&type=template&id=2832d596&scoped=true&"
var script = {}
import style0 from "./FasserramentiLogo.vue?vue&type=style&index=0&id=2832d596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2832d596",
  null
  
)

export default component.exports